const series = ({ serie }) => {
    if (serie.hent == 0) {
        if (serie.status === "Ongoing") {
            return (
                <div key={serie.id} className="serie-ongoing">
                    {serie.type.toString() === "Manga" ? (
                        <a href={"/mangi/" + serie.id}>
                            <img className="photoin" src={`https://cdn.discordapp.com/attachments/${serie.photo_path}`} alt="uwu"></img>
                            {serie.title.length > 45 ? (
                                <div className="name-text">{serie.title}</div>
                            ) : (
                                <div className="name-text big">{serie.title}</div>
                            )}
                        </a>
                    ) : (
                        <a href={"/series/" + serie.id}>
                            <img className="photoin" src={`https://cdn.discordapp.com/attachments/${serie.photo_path}`} alt="uwu"></img>
                            {serie.title.length > 45 ? (
                                <div className="name-text">{serie.title}</div>
                            ) : (
                                <div className="name-text big">{serie.title}</div>
                            )}
                        </a>
                    )}
                </div>
            );
        }
        if (serie.status === "Not Yet") {
            return (
                <div key={serie.id} className="serie-notyet">
                    {serie.type.toString() === "Manga" ? (
                        <a href={"/mangi/" + serie.id}>
                            <img className="photoin" src={`https://cdn.discordapp.com/attachments/${serie.photo_path}`} alt="uwu"></img>
                            {serie.title.length > 45 ? (
                                <div className="name-text">{serie.title}</div>
                            ) : (
                                <div className="name-text big">{serie.title}</div>
                            )}
                        </a>
                    ) : (
                        <a href={"/series/" + serie.id}>
                            <img className="photoin" src={`https://cdn.discordapp.com/attachments/${serie.photo_path}`} alt="uwu"></img>
                            {serie.title.length > 45 ? (
                                <div className="name-text">{serie.title}</div>
                            ) : (
                                <div className="name-text big">{serie.title}</div>
                            )}
                        </a>
                    )}
                </div>
            );
        }
        return (
            <div key={serie.id} className="serie">
                {serie.type.toString() === "Manga" ? (
                    <a href={"/mangi/" + serie.id}>
                        <img className="photoin" src={`https://cdn.discordapp.com/attachments/${serie.photo_path}`} alt="uwu"></img>
                        {serie.title.length > 45 ? (
                            <div className="name-text">{serie.title}</div>
                        ) : (
                            <div className="name-text big">{serie.title}</div>
                        )}
                    </a>
                ) : (
                    <a href={"/series/" + serie.id}>
                        <img className="photoin" src={`https://cdn.discordapp.com/attachments/${serie.photo_path}`} alt="uwu"></img>
                        {serie.title.length > 45 ? (
                            <div className="name-text">{serie.title}</div>
                        ) : (
                            <div className="name-text big">{serie.title}</div>
                        )}
                    </a>
                )}
            </div>
        );
    }
};

export default series;
